import { motion } from "framer-motion";

const o = { stroke: "#12303B", strokeWidth: 3, strokeLinejoin: "round", strokeLinecap: "round" };

export const Churro = () => (
  <svg viewBox="0 0 64 64" className="w-full h-full">
    <path d="M8 46L36 12c6-7 22 3 16 11L24 58c-6 8-22-3-16-12z" fill="#D9963F" {...o} />
    <path d="M18 40l10 8M26 30l10 8M34 21l10 8" {...o} fill="none" />
    <circle cx="20" cy="50" r="1.8" fill="#FBF6EA" /><circle cx="32" cy="34" r="1.8" fill="#FBF6EA" /><circle cx="42" cy="20" r="1.8" fill="#FBF6EA" />
  </svg>
);

export const Cookie = () => (
  <svg viewBox="0 0 64 64" className="w-full h-full">
    <circle cx="32" cy="32" r="24" fill="#E3B26A" {...o} />
    {[[24, 22], [40, 26], [28, 40], [42, 42], [20, 34]].map(([x, y]) => (
      <circle key={`${x}-${y}`} cx={x} cy={y} r="3.4" fill="#5A3A22" />
    ))}
  </svg>
);

export const Donut = () => (
  <svg viewBox="0 0 64 64" className="w-full h-full">
    <circle cx="32" cy="32" r="24" fill="#D9963F" {...o} />
    <path d="M12 30c2-12 12-18 20-18s18 6 20 18c-4 4-6-2-10 2s-6 2-10-1-6 3-10 0-6 2-10-1z" fill="#F48FB1" {...o} />
    <circle cx="32" cy="32" r="7" fill="#12303B" {...o} />
    <path d="M22 20l3 2M38 18l3-1M44 26l2 3M28 16l1 3" stroke="#FBF6EA" strokeWidth="2.4" strokeLinecap="round" />
  </svg>
);

export const LegoCar = () => (
  <svg viewBox="0 0 80 64" className="w-full h-full">
    <rect x="22" y="10" width="10" height="6" rx="1.5" fill="#E8615A" {...o} />
    <rect x="38" y="10" width="10" height="6" rx="1.5" fill="#E8615A" {...o} />
    <rect x="18" y="16" width="34" height="14" rx="2" fill="#E8615A" {...o} />
    <rect x="26" y="19" width="16" height="8" rx="1" fill="#8FD3C1" {...o} />
    <rect x="6" y="30" width="68" height="16" rx="2" fill="#F4C64E" {...o} />
    <path d="M14 30v-4h8v4M58 30v-4h8v4" fill="#F4C64E" {...o} />
    <circle cx="20" cy="48" r="8" fill="#12303B" {...o} /><circle cx="20" cy="48" r="3" fill="#FBF6EA" />
    <circle cx="60" cy="48" r="8" fill="#12303B" {...o} /><circle cx="60" cy="48" r="3" fill="#FBF6EA" />
  </svg>
);

export const Sticker = ({ children, className = "", delay = 0, rotate = 0, testid }) => (
  <motion.div
    data-testid={testid}
    className={`absolute pointer-events-none drop-shadow-md ${className}`}
    initial={{ scale: 0, rotate: rotate - 30 }}
    whileInView={{ scale: 1, rotate }}
    viewport={{ once: true, amount: 0.1 }}
    transition={{ type: "spring", stiffness: 260, damping: 12, delay }}
  >
    <div className="w-full h-full transition-transform duration-300 group-hover:-translate-y-1 group-hover:scale-110">{children}</div>
  </motion.div>
);
